import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const Terms: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-blue-600 hover:text-blue-700 mb-6 transition-colors"
        >
          <ArrowLeft size={20} />
          Back to Login
        </button>

        <div className="bg-white rounded-lg shadow-md p-8">
          <h1 className="text-3xl font-bold mb-6 text-slate-900">Terms of Service</h1>
          <p className="text-slate-600 mb-6">Last updated: December 2024</p>

          <div className="space-y-6 text-slate-700">
            <p>
              By using LessonlyAI, you agree to these terms:
            </p>

            <ul className="list-disc pl-6 space-y-3">
              <li>
                <strong>Beta Service:</strong> This is a beta service provided as-is. We're actively
                developing and improving the platform.
              </li>
              <li>
                <strong>Service Changes:</strong> We reserve the right to modify features, pricing,
                and service availability as we develop the platform.
              </li>
              <li>
                <strong>Ownership:</strong> Your lesson plans are yours - we don't claim ownership
                of the content you create.
              </li>
              <li>
                <strong>Free Tier:</strong> Free tier includes 5 AI-generated lessons per month.
                Additional usage may require a paid subscription.
              </li>
              <li>
                <strong>Feedback:</strong> We may contact you for feedback during the beta period
                to improve the service.
              </li>
              <li>
                <strong>TEKS Alignment:</strong> While we strive for accurate TEKS alignment,
                you are responsible for verifying that lesson plans meet your specific requirements.
              </li>
              <li>
                <strong>AI-Generated Content:</strong> Lesson plans are generated using AI and
                should be reviewed and adapted as needed for your classroom.
              </li>
              <li>
                <strong>Account Security:</strong> You are responsible for maintaining the
                confidentiality of your account credentials.
              </li>
            </ul>

            <div className="mt-8 pt-6 border-t border-slate-200">
              <h2 className="text-xl font-semibold mb-3">Contact</h2>
              <p>
                Questions about our terms?{' '}
                <a
                  href="mailto:pablo@lessonlyai.com"
                  className="text-blue-600 hover:underline"
                >
                  pablo@lessonlyai.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
